export const TREATMENT_FILTER_SETTINGS = {
    slidesToShow: 5,
    slidesToScroll: 3,
    infinite: false,
    arrows: true,
    // variableWidth: true,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                // initialSlide: 1,
                // className: 'center',
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

export const BOOKING_LINK_STEP = {
    LOCATION: 1,
    TREATMENT: 2,
    DATE_AND_TIME: 3,
    TEAM_MEMBER: 4,
    CLIENT_DETAILS: 5,
};

export const DISCOUNT_NOT_APPLICABLE_MSG = "Discount can't be applied for selected payment option";

export const DISCOUNT_CODE_SUCCESS_MSG = "Coupon code applied successfully.";